/* mo-lineup-dreamcloud.js: the DreamCloud look for sections/mo-brand-lineup.liquid (2026-10-06).
 * Loaded only with that look, before mo-brand-lineup.js. Vanilla JS, no libraries, no showpiece.
 * The page is complete without this file. It does four small things:
 * 1. marks the lineup root with the look class and data-draw, so the shared root line stays as it is;
 * 2. reads "California King" as the Cal King button (DreamCloud's memory foam listings name the size
 *    one way, its hybrids the other; the price shown is that variant's own);
 * 3. shows DreamCloud's two feel words the shared list lacks (Medium-soft, Extra firm);
 * 4. draws each row's side view (window.MOLineupDraw.dreamcloud): height to scale at 5 units per
 *    inch like every lineup drawing, a layer at its published depth where its name gives one
 *    ("2 in."), the rest of the split illustrative. */
(function () {
  'use strict';

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function setAttr(el, name, value) { if (el && el.getAttribute(name) !== value) el.setAttribute(name, value); }

  var FEEL_WORDS = { 'soft': 'Medium-soft', 'ultra-firm': 'Extra firm' };

  function setup(scope) {
    all('[data-mo-lineup]', scope).forEach(function (root) {
      if (!root.querySelector('.mo-lineup__hero--dc') || root.__moDc) return;
      root.__moDc = true;
      root.classList.add('mo-lineup--dreamcloud');
      if (!root.getAttribute('data-draw')) root.setAttribute('data-draw', 'dreamcloud');

      /* one size, two names: the size picker lists Cal King */
      all('[data-sizes-json]', root).forEach(function (node) {
        try {
          var sizes = JSON.parse(node.textContent);
          if (sizes['California King'] && !sizes['Cal King']) {
            sizes['Cal King'] = sizes['California King'];
            delete sizes['California King'];
            node.textContent = JSON.stringify(sizes);
          }
        } catch (e) { /* leave the data as served */ }
      });

      /* DreamCloud's own feel words */
      Object.keys(FEEL_WORDS).forEach(function (key) {
        var word = FEEL_WORDS[key];
        all('[data-feels] button[data-feel="' + key + '"]', root).forEach(function (b) { setText(b, word); });
        all('.mo-lineup__v[data-feel="' + key + '"]', root).forEach(function (v) {
          setAttr(v, 'data-feel-name', word);
          setText(v.querySelector('.mo-lineup__feel-name'), word);
          setAttr(v.querySelector('.mo-lineup__meter'), 'aria-label', 'Feel: ' + word.toLowerCase());
        });
      });

      /* the switch on a row changes the build, not the firmness */
      all('.mo-lineup__pick', root).forEach(function (group) {
        var label = group.getAttribute('aria-label') || '';
        if (/ firmness$/.test(label)) group.setAttribute('aria-label', label.replace(/ firmness$/, ' build'));
      });

      /* a photo at the top jumps to its row; if the feel filter has hidden that row, show all first */
      root.addEventListener('click', function (e) {
        var bed = e.target.closest && e.target.closest('[data-dc-bed]');
        if (!bed) return;
        var row = document.getElementById((bed.getAttribute('href') || '').slice(1));
        var every = root.querySelector('[data-feels] button[data-feel="all"]');
        if (row && row.hidden && every) every.click();
      }, true);

      /* the floor filter shows only if a bed has a floor record */
      if (all('.mo-lineup__v', root).some(function (v) { return (v.getAttribute('data-floor') || '').trim(); })) root.classList.add('mo-dc-has-floor');
    });
  }

  /* ---------- row drawing ----------
   * A side view with the cover cut back: the finished side on the left, the build on the right. */
  var WEIGHT = { 'dc-top': 1.5, 'dc-top-euro': 1.5, 'dc-top-plus': 1.6, 'dc-pcm': 0.3, 'dc-memory': 1.9, 'dc-support': 1.2, 'dc-zoned3': 2, 'dc-zoned5': 2, 'dc-coils': 8, 'dc-core': 8, 'dc-base': 1 };
  var drawn = 0;
  function n1(v) { return Math.round(v * 10) / 10; }

  function draw(version, inches, kinds) {
    var lis = version ? all('.mo-lineup__layers li', version) : [];
    var layers = (lis.length ? lis.map(function (li) {
      var m = /(\d+(?:\.\d+)?)\s*in\./i.exec(li.textContent || '');
      return { kind: (li.getAttribute('data-kind') || '').trim(), inches: m ? parseFloat(m[1]) : 0 };
    }) : kinds.map(function (k) { return { kind: k, inches: 0 }; })).filter(function (l) { return WEIGHT[l.kind]; });
    if (!layers.length) layers = [{ kind: 'dc-top', inches: 0 }, { kind: 'dc-core', inches: 0 }];

    var id = 'mo-dcut-' + (++drawn);
    var VW = 204, VH = 118, X0 = 12, X1 = 198, U = 5, FLOOR = 107;
    var h = Math.max(48, Math.min(inches * U, 84)), top = FLOOR - h;
    var CUT = X0 + (X1 - X0) * 0.26, slope = 0.16;
    function cx(y) { return CUT + (y - top) * slope; }

    /* heights: published inches first, the other layers share what is left */
    var fixed = 0, wsum = 0;
    layers.forEach(function (l) { if (l.inches) { l.hh = l.inches * U; fixed += l.hh; } else { wsum += WEIGHT[l.kind]; } });
    var share = h - fixed > 5 ? h - fixed : h * 0.25;
    layers.forEach(function (l) { if (!l.inches) l.hh = share * WEIGHT[l.kind] / wsum; });
    var total = 0; layers.forEach(function (l) { total += l.hh; });
    layers.forEach(function (l) { l.hh *= h / total; });

    var topLayer = /^dc-top/.test(layers[0].kind) ? layers[0] : null;
    var plus = !!topLayer && topLayer.kind === 'dc-top-plus', euro = !!topLayer && topLayer.kind !== 'dc-top';
    var seam = top + (topLayer ? topLayer.hh : 0);
    var o = '<defs><clipPath id="' + id + '"><path d="M' + n1(cx(top - 45)) + ',' + n1(top - 45) + 'H' + (X1 + 2) + 'V' + FLOOR + 'H' + n1(cx(FLOOR)) + 'Z"/></clipPath></defs>';
    o += '<ellipse class="dc-shadow" cx="' + ((X0 + X1) / 2) + '" cy="' + (FLOOR + 2.4) + '" rx="' + ((X1 - X0) / 2 + 4) + '" ry="2.2"/>';
    o += '<path class="dc-dim" d="M5,' + n1(top) + 'V' + FLOOR + 'M2.4,' + n1(top) + 'h5.2M2.4,' + FLOOR + 'h5.2"/>';

    /* the build, right of the cut; the comfort layers lift apart when the list opens */
    o += '<g clip-path="url(#' + id + ')">';
    var y = top, lifts = layers.filter(function (l) { return !/coils|core|base/.test(l.kind); }).length, li = 0;
    layers.forEach(function (l) {
      var y0 = y, y1 = y + l.hh, k = l.kind, type = k.replace(/^dc-/, '').replace(/\d$/, ''), x, i;
      var lift = /coils|core|base/.test(k) ? 0 : (lifts - li++) * 3.2;
      o += '<g' + (lift ? ' class="c-lift" style="--lift:' + n1(lift) + '"' : '') + '>';
      if (/^dc-top/.test(k)) {
        /* the quilted top: a row of shallow puffs along the top edge, deeper on a Euro top */
        var puffs = 9, step = (X1 - X0) / puffs, amp = euro ? 2.1 : 1.1, d = 'M' + X0 + ',' + n1(y0 + amp);
        for (i = 0; i < puffs; i++) d += 'Q' + n1(X0 + step * (i + 0.5)) + ',' + n1(y0 - amp) + ' ' + n1(X0 + step * (i + 1)) + ',' + n1(y0 + amp);
        o += '<path class="dc-quilt' + (plus ? ' is-plus' : '') + '" d="' + d + 'V' + n1(y1) + 'H' + X0 + 'Z"/>';
        for (i = 1; i < puffs; i++) o += '<path class="dc-line" d="M' + n1(X0 + step * i) + ',' + n1(y0 + amp) + 'V' + n1(Math.min(y1, y0 + amp + l.hh * 0.55)) + '"/>';
      } else {
        o += '<rect class="dc-l-' + type + '" x="' + X0 + '" y="' + n1(y0) + '" width="' + (X1 - X0) + '" height="' + n1(Math.max(0.7, l.hh - 0.4)) + '"/>';
        if (type === 'zoned') {
          /* zones run head to foot: three or five bands along the length */
          var zones = k === 'dc-zoned5' ? 5 : 3, zw = (X1 - cx(y0)) / zones;
          for (i = 1; i < zones; i += 2) o += '<rect class="dc-zone" x="' + n1(cx(y0) + zw * i) + '" y="' + n1(y0) + '" width="' + n1(zw) + '" height="' + n1(Math.max(0.7, l.hh - 0.4)) + '"/>';
        }
        if (type === 'coils') {
          var count = 13, xs = cx(y0) + 3, xe = X1 - 2.5, pitch = (xe - xs) / count, c, j, turns = 5, p, yy, dir;
          for (i = 0; i < count; i++) {
            c = xs + pitch * (i + 0.5);
            o += '<rect class="dc-pocket" x="' + n1(c - pitch * 0.44) + '" y="' + n1(y0 + 0.9) + '" width="' + n1(pitch * 0.88) + '" height="' + n1(l.hh - 2) + '" rx="2"/>';
            p = (l.hh - 5) / (turns * 2); yy = y0 + 2.5; dir = 1; d = 'M' + n1(c) + ',' + n1(yy);
            for (j = 0; j < turns * 2; j++) { d += 'Q' + n1(c + dir * pitch * 0.5) + ',' + n1(yy + p / 2) + ' ' + n1(c) + ',' + n1(yy + p); yy += p; dir = -dir; }
            /* DreamCloud says the edges are reinforced: the outer coil is drawn heavier */
            o += '<path class="dc-coil"' + (i === count - 1 ? ' style="stroke-width:1.5"' : '') + ' d="' + d + '"/>';
          }
        } else if (l.hh > 2.2) {
          o += '<path class="dc-hl" d="M' + X0 + ',' + n1(y0 + 0.9) + 'H' + X1 + '"/>';
        }
      }
      o += '</g>';
      y = y1;
    });
    o += '</g>';

    /* the finished side, left of the cut: quilt edge, Euro top band, channelled border, piping */
    var side = 'M' + (X0 + 3) + ',' + n1(top) + 'H' + n1(cx(top)) + 'L' + n1(cx(FLOOR)) + ',' + FLOOR + 'H' + (X0 + 3) + 'Q' + X0 + ',' + FLOOR + ' ' + X0 + ',' + (FLOOR - 3) + 'V' + n1(top + 3) + 'Q' + X0 + ',' + n1(top) + ' ' + (X0 + 3) + ',' + n1(top) + 'Z';
    o += '<path class="dc-side" d="' + side + '"/>';
    if (euro) o += '<path class="dc-band" d="M' + X0 + ',' + n1(top + 3) + 'Q' + X0 + ',' + n1(top) + ' ' + (X0 + 3) + ',' + n1(top) + 'H' + n1(cx(top)) + 'L' + n1(cx(seam)) + ',' + n1(seam) + 'H' + X0 + 'Z"/>';
    for (var x2 = X0 + 5.5; x2 < cx(FLOOR) - 3; x2 += 5.5) {
      var chanTop = Math.max(seam + 2, top + (x2 - CUT + 3) / slope);
      if (chanTop < FLOOR - 6) o += '<path class="dc-chan" d="M' + n1(x2) + ',' + n1(chanTop) + 'V' + (FLOOR - 2.5) + '"/>';
    }
    o += '<path class="dc-quilt' + (plus ? ' is-plus' : '') + '" d="M' + (X0 + 2) + ',' + n1(top - 0.2) + 'H' + n1(cx(top) - 0.4) + 'L' + n1(cx(top + 2.6) - 0.4) + ',' + n1(top + 2.6) + 'H' + (X0 + 0.6) + 'Z"/>';
    if (euro) o += '<path class="dc-pipe" d="M' + (X0 + 0.8) + ',' + n1(seam) + 'H' + n1(cx(seam) - 0.6) + '"/>';
    o += '<path class="dc-pipe" d="M' + (X0 + 1.5) + ',' + (FLOOR - 1.2) + 'H' + n1(cx(FLOOR - 1.2) - 0.6) + '"/>';
    o += '<path class="dc-out" d="M' + n1(cx(top)) + ',' + n1(top) + 'L' + n1(cx(FLOOR)) + ',' + FLOOR + '"/>';
    o += '<path class="dc-floor" d="M2,' + (FLOOR + 0.6) + 'H' + (VW - 1) + '"/>';
    return '<svg viewBox="0 0 ' + VW + ' ' + VH + '" aria-hidden="true" focusable="false">' + o + '</svg>';
  }

  window.MOLineupDraw = window.MOLineupDraw || {};
  window.MOLineupDraw.dreamcloud = draw;
  setup(document);
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
